<div class="checkout-delivery-container">
  <div class="content">
    <div class="headline">{{ 'checkout.steps.delivery.headline' | translate }}</div>
    <div class="deliveryMethod selected " *ngFor="let deliveryMethod of deliveryMethods$ | async">
      <div class="headline">
        <div class="name">
          <kion-radio [title]="deliveryMethod.name" [selected]="(activeDeliveryMethod$ | async)?.code === deliveryMethod.code" (selected)="selectMethod(deliveryMethod)"></kion-radio>
        </div>
        <div class="currency" *ngIf="deliveryMethod.deliveryCost as cost">
          {{ cost.formattedValue }}
        </div>
      </div>
      <div class="description"> {{ deliveryMethod.description }} </div>
    </div>
    <div class="note">
      <div class="headline">
        {{ 'checkout.steps.delivery.note.headline' | translate }}
      </div>
      <div class="note" [formGroup]="form">
        <label for="note"></label>
        <textarea id="note" [placeholder]="'checkout.steps.delivery.note.placeHolder' | translate" formControlName="note"></textarea>
      </div>
    </div>
  </div>
  <div class="navigator">
    <div class="back">
      <kion-label-button [title]="'checkout.navigator.back' | translate" [link]="backLink">
        <svg img-link xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
          <path fill="#9B9B9E" fill-rule="evenodd" d="M14.286 4.571L2.522 4.571 6.118 0.975 5.31 0.167 0.335 5.143 5.31 10.118 6.118 9.31 2.522 5.714 14.286 5.714z" transform="translate(.571 2.857)"></path>
        </svg>
      </kion-label-button>
    </div>
    <div class="forward">
      <kion-button mode="primary" [title]="'checkout.navigator.forward' | translate"  [isLink]="true" [link]="forwardLink" [disabled]="!(canProceed$ | async)"></kion-button>
    </div>
  </div>
</div>
